import { useEffect } from 'react';
import AccountDataInfo from '../data/account';
import { requestGoogleProtobuf } from '../utilities/request-google-protobuf';

const UseAccount = () => {
  const token = localStorage.getItem('trade.token');
  const metadata = { Authorization: 'Bearer ' + token };
  const accountSteam = new AccountDataInfo();

  useEffect(() => {
    accountSteam.accountInfo(requestGoogleProtobuf, metadata);
  }, []);
  
  const reFetch = () => {
    accountSteam.accountInfo(requestGoogleProtobuf, metadata);
  }

  return { reFetch };
};

export default UseAccount;